import { render } from "./serial-number.html?vue&type=template&id=5bcd82fc&scoped=true&ts=true"
import script from "./serial-number.ts?vue&type=script&lang=ts"
export * from "./serial-number.ts?vue&type=script&lang=ts"

import "./serial-number.scss?vue&type=style&index=0&id=5bcd82fc&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcd82fc"]])

export default __exports__